import {
	type NavbarBranchItem,
	fetchNavbarTreeQueryOptions,
	navbarTreeQueryKeys,
	seedBranchCacheFromTree,
} from "@src/components/board/queries/fetch-ranklist";
import { NavbarSection } from "@src/gql/graphql";
import type { QueryClient } from "@tanstack/react-query";

const SHELL_NAVBAR_TREE_SECTIONS: readonly NavbarSection[] = [
	NavbarSection.MyWhiteboards,
	NavbarSection.SharedWithMe,
	NavbarSection.Favourites,
];

/**
 * Warms per-branch React Query caches before nav mounts (see seedBranchCacheFromTree).
 * Best-effort: failures do not block the shell.
 */
export async function prefetchNavbarTreesForShell(
	queryClient: QueryClient,
): Promise<void> {
	await Promise.all(
		SHELL_NAVBAR_TREE_SECTIONS.map(async (section) => {
			try {
				await queryClient.prefetchQuery(fetchNavbarTreeQueryOptions(section));
				const items = queryClient.getQueryData<NavbarBranchItem[]>(
					navbarTreeQueryKeys.tree(section),
				);
				if (items?.length) {
					seedBranchCacheFromTree(queryClient, section, items);
				}
			} catch {
				// Navbar is non-critical for first paint; panels still use useNavbarTreePrefetch.
			}
		}),
	);
}
